import { render } from "./role.vue?vue&type=template&id=659d9151&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=659d9151&lang=less&scoped=true"
import "./role.vue?vue&type=style&index=1&id=659d9151&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659d9151"]])

export default __exports__